import AuthForm, { STATE_LOGIN } from 'components/AuthForm';
import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import { MdAccountCircle } from "react-icons/md";

class AuthPage extends React.Component {
  handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      this.props.history.push('/login');
    } else {
      this.props.history.push('/signup');
    }
  };

  handleLogoClick = () => {
    this.props.history.push('/');
  };

  render() {
    //const element = [(), null]
    return (
      <Row
        style={{
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Col md={6} lg={3}>
          <Card body>
          <AuthForm
            authState={this.props.authState}
            onChangeAuthState={this.handleAuthState}
            onLogoClick={this.handleLogoClick}
          />
          </Card>
        </Col>
      </Row>
    );
  }
}

export default AuthPage;
